import Reveal from "@/components/Reveal";

const PageHero = ({ overline, title, description, statement, image, imageAlt, dark = false, testId }) => (
  <section
    className={`border-b pt-40 lg:pt-48 ${dark ? "border-white/10 bg-ink" : "border-ink/10 bg-sand"}`}
    data-testid={testId}
  >
    <div className="mx-auto max-w-7xl px-6 pb-16 lg:px-12 lg:pb-24">
      <div className={`grid grid-cols-1 items-end gap-10 ${image ? "lg:grid-cols-12" : ""}`}>
        <Reveal className={image ? "lg:col-span-7" : "max-w-3xl"}>
          <p
            className={`text-xs font-semibold uppercase tracking-[0.28em] ${dark ? "text-brand-light" : "text-brand-dark"}`}
            data-testid={`${testId}-overline`}
          >
            {overline}
          </p>
          <h1
            className={`mt-5 font-display text-5xl leading-[1.05] tracking-tight md:text-6xl lg:text-7xl ${dark ? "text-white" : "text-ink"}`}
            data-testid={`${testId}-title`}
          >
            {title}
          </h1>
          {statement && (
            <p
              className={`mt-6 font-display text-xl italic md:text-2xl ${dark ? "text-brand-light" : "text-brand-dark"}`}
              data-testid={`${testId}-statement`}
            >
              {statement}
            </p>
          )}
          {description && (
            <p
              className={`mt-6 max-w-2xl text-base leading-relaxed md:text-lg ${dark ? "text-white/65" : "text-ink/65"}`}
              data-testid={`${testId}-description`}
            >
              {description}
            </p>
          )}
        </Reveal>
        {image && (
          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -left-3 -top-3 h-full w-full border border-brand/40" aria-hidden="true" />
              <img src={image} alt={imageAlt} className="relative h-64 w-full object-cover md:h-80" loading="eager" />
            </div>
          </Reveal>
        )}
      </div>
    </div>
  </section>
);

export default PageHero;
